import React, { useEffect, useState } from 'react';

import { withRouter, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import JiraPersonalNotification from '../presonal_notification';
import CreationDefault from './creationDefault';
// import queryString from "query-string";
// import { getTeamData,updateTeam,updateSkill,getConfluenceSpaces} from "../../skills_action";

import { Row, Col, Select } from 'antd';

// import { AppHomeSection } from './apphomesection.js';

const { Option } = Select;

const MemberPreference = (props) => {
  const usermappings = useSelector((state) => {
    // console.log(state)
    return (
      state.skills.usermappings &&
      state.skills.usermapping.userMappingsWithUsers.filter((u) => u.isVerified)
    );
  });
  const global_row_gutter = useSelector((state) => {
    return state.common_reducer.global_row_gutter;
  });

  const [selectedMember, setSelectedMember] = useState(null);
  const selectMember = (e, field) => {
    setSelectedMember(field);
  };
  return (
    <Row gutter={global_row_gutter}>
      <Col
        span={24}
        id='select_mapped_user'
        // xs={{ span: 24 }}
        // sm={{ span: 24 }}
        // lg={{ span: 12 }}
        // xxl={{ span: 12 }}
        style={{ width: '100%' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div>Select User:</div>
          <div style={{ marginLeft: 8 }}>
            <Select
              style={{ width: 300 }}
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onSearch
              onChange={(e, field) => selectMember(e, field)}
            >
              {usermappings.map((mUser) => (
                <Option
                  key={mUser.user_obj.accountId}
                  value={mUser.user_id.user_id}
                >
                  {mUser.user_id.displayName || mUser.user_id.name}{' '}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </Col>
      {selectedMember && (
        <Col span={24} id='personal_notification'>
          <JiraPersonalNotification
            channelId={props.channelId}
            sConfigMember={selectedMember.value}
            accountId={selectedMember.key}
          />
          <CreationDefault
            subSkill={props.match.params.sub_skill}
            botChannel={props.channelId}
          />
        </Col>
      )}
    </Row>
  );
};

export default withRouter(MemberPreference);
